<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
              <span class="title-404">404 Not Found</span>
              <h2 class="title title-404-info mb-7">
                Страница не найдена :(
              </h2>
              <v-btn
                class="customGlobalBtn mb-0 emptyBtn"
                variant="text"
                text
                @click="goTo()"
              >
                Вернуться на главную
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goTo() {
      this.$router.push({
        name: 'profile'
      });
    }
  }
};
</script>
